/**
 * NMU-532: one set of validation messages for every form in the admin.
 *
 * "โปรดระบุ" under an empty box says nothing an empty box does not already say,
 * and the same two words appeared under every field on every page — worst on a
 * form with several required fields, where the messages were indistinguishable
 * from each other.
 *
 * These use antd's own `${label}` template, so each message names the field it
 * sits under and keeps naming it when someone renames the label. That is why
 * this is a template rather than a table of per-field strings: a table drifts
 * the first time a label changes, and drifts silently.
 *
 * Applied once, at the ConfigProvider in src/App.js, so a form inherits them by
 * existing rather than by remembering to opt in. A field that needs different
 * wording — an upload, say — still overrides with `message` on its own rule.
 */
/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: 'กรุณาระบุ${label}',
  types: {
    email: 'รูปแบบ${label}ไม่ถูกต้อง',
    url: 'รูปแบบ${label}ไม่ถูกต้อง',
    number: '${label}ต้องเป็นตัวเลข',
  },
  string: {
    max: '${label}ต้องไม่เกิน ${max} ตัวอักษร',
  },
  number: {
    min: '${label}ต้องไม่น้อยกว่า ${min}',
    max: '${label}ต้องไม่เกิน ${max}',
  },
};
/* eslint-enable no-template-curly-in-string */

export default validateMessages;
